import { ref, computed } from 'vue'
import { apiClient } from '@/services/auth-header'

export function useViewLogs() {
  const viewLogs = ref([])
  const selectedContentType = ref('')
  const isLoading = ref(false)

  // 통계 계산
  const totalViews = computed(() => viewLogs.value.length)
  
  const uniqueVisitors = computed(() => {
    const uniqueUsers = new Set(viewLogs.value.map(log => log.userAccountId))
    return uniqueUsers.size
  })

  // API 호출
  const fetchViewLogs = async () => {
    isLoading.value = true
    try {
      const params = selectedContentType.value ? { contentType: selectedContentType.value } : {}
      const response = await apiClient.get('/view-logs/analysis', { params })
      viewLogs.value = response.data
    } catch (error) {
      console.error('조회 로그 데이터를 가져오는데 실패했습니다:', error)
      viewLogs.value = []
      throw error
    } finally {
      isLoading.value = false
    }
  }

  // 필터 초기화
  const resetFilters = () => {
    selectedContentType.value = ''
    fetchViewLogs()
  }

  return {
    // 상태
    viewLogs,
    selectedContentType,
    isLoading,
    
    // 계산된 값
    totalViews,
    uniqueVisitors,
    
    // 메서드
    fetchViewLogs,
    resetFilters
  }
}